import { render } from "./CategoriesPopupFiltersModal.vue?vue&type=template&id=c6ddbefc&scoped=true"
import script from "./CategoriesPopupFiltersModal.vue?vue&type=script&lang=js"
export * from "./CategoriesPopupFiltersModal.vue?vue&type=script&lang=js"

import "./CategoriesPopupFiltersModal.vue?vue&type=style&index=0&id=c6ddbefc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6ddbefc"],['__file',"src/components/CategoriesPopupFiltersModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6ddbefc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6ddbefc', __exports__)) {
    api.reload('c6ddbefc', __exports__)
  }
  
  module.hot.accept("./CategoriesPopupFiltersModal.vue?vue&type=template&id=c6ddbefc&scoped=true", () => {
    api.rerender('c6ddbefc', render)
  })

}


export default __exports__